import React, { useState } from 'react';
import { Button, InputGroup, Form } from 'react-bootstrap';
import { FaPencilAlt, FaCheck, FaTimes } from 'react-icons/fa';

// Remove 'isLive' from the props list as it's no longer needed
const EditablePriceItem = ({ label, value, currency, fieldKey, onSave, tabIndex, onNavigate }) => {
  const priceValue = value ?? 0;
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(priceValue);

  const handleEditClick = () => {
    // --- SIMPLIFIED CORE LOGIC ---
    // If a tabIndex is provided, navigate. That's it.
    if (tabIndex) {
      onNavigate(tabIndex);
    } else {
      // If no tabIndex is provided, do the normal inline editing.
      setCurrentValue(priceValue);
      setIsEditing(true);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = () => {
    onSave(fieldKey, currentValue);
    setIsEditing(false);
  };

  return (
    <div className="list-group-item d-flex justify-content-between align-items-center">
      {isEditing ? (
        // This part for inline editing remains the same
        <>
          <InputGroup>
            <InputGroup.Text><strong>{label}:</strong></InputGroup.Text>
            <Form.Control
              type="number"
              value={currentValue}
              onChange={(e) => setCurrentValue(e.target.value)}
              autoFocus
            />
            <InputGroup.Text>{currency}</InputGroup.Text>
          </InputGroup>
          <div className="ms-2">
            <Button variant="success" size="sm" onClick={handleSave} className="me-1">
              <FaCheck />
            </Button>
            <Button variant="danger" size="sm" onClick={handleCancel}>
              <FaTimes />
            </Button>
          </div>
        </>
      ) : (
        // The display part also remains the same
        <>
           <span>
            <strong>{label}:</strong> {priceValue.toLocaleString()} {currency}
          </span>
          <Button variant="outline-primary" size="sm" onClick={handleEditClick}>
            <FaPencilAlt />
          </Button>
        </>
      )}
    </div>
  );
};

export default EditablePriceItem;